import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";


import {ItemBoostRule} from "@/modules/redactor/models/item/boost/ItemBoostRule";
import {ItemBoostMode} from "@/modules/redactor/models/item/boost/ItemBoostMode";

export class ItemBoostConfig extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(ItemBoostConfig, v) : SKIP;
            },
            (v) => {
                return deserialize(ItemBoostConfig, v);
            }
        );
    }

    constructor() {
        super();

        this._mode = ItemBoostMode.DISABLED;

        this._rules = [];
    }

    get mode() {
        return this._mode;
    }

    set mode(value) {
        this._mode = value;
        this._rules = [];
        this._price = [];
    }

    get rules() {
        return this._rules;
    }

    set rules(value) {
        this._rules = value;
    }

    valid() {

        if (this.mode.equal(ItemBoostMode.DISABLED)) {
            return true;
        } else if (this.mode.equal(ItemBoostMode.ITEM_AMOUNT)) {
            if (!this.rules || this.rules.length === 0) {
                return false;
            }
        } else if (this.mode.equal(ItemBoostMode.ITEM_POINTS)) {
            if (!this.rules || this.rules.length === 0) {
                return false;
            }
        } else {
            return false;
        }

        if (!this.rules || this.rules.some(v => !v || !v.valid())) {
            return false;
        } else {
            for (let i = 0; i < this.rules.length - 1; i++) {
                for (let j = i + 1; j < this.rules.length; j++) {
                    if (this.rules[i].collide(this.rules[j])) {
                        return false;
                    }
                }
            }
        }

        return true;
    }

    empty() {
        return this.mode.equal(ItemBoostMode.DISABLED);
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemBoostConfig());
        } else if (target instanceof ItemBoostConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemBoostConfig, {
    _mode: alias("mode", ItemBoostMode.schema()),
    _rules: alias("rules", list(ItemBoostRule.schema())),
});